import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DocumentTemplateListView } from './report-list.view';
import { DocumentTemplateListDataService } from './report-list.data';
import { DocumentTemplateCategorySummariesDataService } from '../general/document-template-categories/document-template-category.data';

@observer
export class DocumentTemplateListController extends React.Component<ControllerProps<any>, any> {
	@resolve
	toast: ToastNotifications;

	@observable
	dataService: DocumentTemplateListDataService;

	@observable
	templateCategoriesDataService: DocumentTemplateCategorySummariesDataService;

	@observable
	categories: DocumentTemplateCategorySummary[] = [];

	@observable
	categoryId: number;

	public componentDidMount() {
		this.loadCategories();
	}

	public render() {
		return (
			<DocumentTemplateListView
				model={this.dataService}
				setBusy={this.props.setBusy}
				categoryId={this.categoryId}
				filterData={this.filterData}
				categories={this.categories}
			/>
		);
	}
	
	private loadData = async (): Promise<void> => {
		this.dataService = DocumentTemplateListDataService.make();

		this.dataService.addFilter('isDocument', 'eq', false);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.pageSize = 25;

		try {
			this.props.setBusy(true);
			await this.dataService.load(query => query);
		} catch (error) {
			this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
		} finally {
			this.props.setBusy(false);
		}
	}
	
	private loadCategories = async (): Promise<void> => {
		const items = await this.templateCategoryQuery();
		this.categories.push({
			id: -1,
			displayName: 'ALL'
		});
		this.categories.push({
			id: -2,
			displayName: 'Favorites'
		});
		for (let cat of items) {
			this.categories.push({
				id: cat.id,
				displayName: cat.displayName
			});

		}
		this.categoryId = -1;

		this.loadData();
	}

	private templateCategoryQuery = async (): Promise<IDocumentTemplateCategorySummary[]> => {
		if (this.templateCategoriesDataService == null) {
			this.templateCategoriesDataService = DocumentTemplateCategorySummariesDataService.make();
		}
		this.templateCategoriesDataService.addFilter("type", "eq", 4);
		this.templateCategoriesDataService.addSorting('id', 'asc');
		this.templateCategoriesDataService.pageSize = 25;
		return this.templateCategoriesDataService.load(query => query);
	}

	private filterData = async (categoryId: number): Promise<IDocumentTemplateSummary[]> => {
		if (categoryId == -1 || categoryId == -2) {
			this.dataService.removeFilter('categoryId');
		} else if (categoryId > 0) {
			this.dataService.addFilter('categoryId', 'eq', categoryId);
		}
		this.categoryId = categoryId;
		return this.dataService.reload();
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/report-list.controller.tsx